// extracted by mini-css-extract-plugin
module.exports = {"brandLinks":"_aea6e13","brandLink":"_28701e2","active":"_3ecdf5d","icon":"_3014fc5","mobileBrandsIcon":"_ffc7449","withAccent":"_7457a2d","foxbet":"_53b80c2"};